/* Cart Reward Progress (Pochette) — PARABAYA
   - Pochette coeur offerte au seuil : le JS ajoute/retire uniquement la variante, jamais le prix
   - Exclut la ligne cadeau du calcul d'éligibilité au seuil
   - Déplace la section sous la barre de livraison gratuite du Cart Drawer
*/

(function() {
    const SELECTOR_SECTION = '[id^="crp-pochette-"].crp-wrapper';
    const SELECTOR_DRAWER = '.cart-drawer, [data-name="cart-drawer"]';
    const SELECTOR_FREEBAR = '.free-shipping-bar, .free-shipping, .free-shipping-bar__bar, .free-shipping__bar';

    function qs(a, b = document) { return b.querySelector(a); }

    function qsa(a, b = document) { return Array.from(b.querySelectorAll(a)); }

    function moveIntoDrawer(section) {
        const drawer = qs(SELECTOR_DRAWER) || qs('#CartDrawer, .js-cart-drawer');
        if (!drawer) return;

        const freeBar = qs(SELECTOR_FREEBAR, drawer);
        if (freeBar && freeBar.parentNode) {
            freeBar.parentNode.insertAdjacentElement('afterend', section);
        } else {
            const footer = qs('.cart-drawer__footer, .cart-drawer__footer-container, .cart__footer', drawer);
            if (footer && footer.parentNode) {
                footer.parentNode.insertBefore(section, footer);
            } else {
                const fallback = qs('.cart-drawer__content, .cart-drawer__content-item, .cart__items', drawer);
                if (fallback) fallback.appendChild(section);
            }
        }
        section.classList.add('crp-anim-enter');
        setTimeout(() => section.classList.remove('crp-anim-enter'), 150);
    }

    async function fetchCart() {
        try {
            const res = await fetch('/cart.js', { credentials: 'same-origin' });
            if (!res.ok) return null;
            return await res.json();
        } catch (_) {
            return null;
        }
    }

    function dispatchDrawerRefresh() {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    }

    function getGiftLine(cart, giftProductId) {
        if (!cart || !giftProductId) return null;
        return cart.items.find(item => String(item.product_id) === String(giftProductId)) || null;
    }

    // ————— Jeton de génération : un cycle de rendu périmé (réponse arrivée en retard) ne doit
    // jamais écraser l'affichage avec un état plus ancien que le dernier cycle lancé. —————
    function nextRenderToken(section) {
        section.__crpToken = (section.__crpToken || 0) + 1;
        return section.__crpToken;
    }

    // ————— Bind une seule fois le message "idle" pour y insérer <span class="crp-missing"> —————
    function bindIdleTemplate(section) {
        const idleP = qs('.crp-msg--idle', section);
        if (!idleP || idleP.dataset.bound === '1') return;

        // Source template: data-crp-idle-text (idéal) ou HTML actuel
        let tpl = section.dataset.crpIdleText || idleP.innerHTML || '%missing%€ restants pour obtenir votre pochette PARABAYA.';

        // Assure qu'il y a <span class="crp-missing"> autour de %missing%
        if (tpl.includes('%missing%')) {
            tpl = tpl.replace('%missing%', '<span class="crp-missing">%missing%</span>');
        } else {
            // Pas de placeholder: on force un template stable "VAL € + le reste"
            const txt = idleP.textContent.trim();
            const rest = txt.replace(/^\s*\d+[.,]?\d*\s*€?\s*/, '').trim() || 'restants pour obtenir votre pochette PARABAYA.';
            tpl = `<span class="crp-missing">%missing%</span>€ ${rest}`;
        }

        idleP.innerHTML = tpl;
        idleP.dataset.bound = '1';
    }

    function setIdleText(section, missingCents) {
        bindIdleTemplate(section); // garantit la présence du span
        const span = qs('.crp-msg--idle .crp-missing', section);
        if (!span) return;
        span.textContent = (missingCents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0 });
        span.style.setProperty('font-weight', '700', 'important'); // au cas où le thème écrase
    }

    function setReachedText(section) {
        const reachedP = section.querySelector('.crp-msg--reached');
        const tpl = section.dataset.crpReachedText || 'Votre magnifique pochette est débloquée 😍';
        if (reachedP) reachedP.innerHTML = tpl;
    }

    function syncGiftSelection(section, giftLine) {
        const selectedVariantId = giftLine ? String(giftLine.variant_id) : null;
        qsa('[data-crp-gift-card]', section).forEach(card => {
            const isSelected = selectedVariantId !== null && card.dataset.crpVariantId === selectedVariantId;
            card.classList.toggle('crp-gift-card--selected', isSelected);
            const radio = qs('.crp-gift-radio', card);
            if (radio) radio.checked = isSelected;
        });
    }

    async function removeGiftLine(giftLine) {
        if (!giftLine) return;
        await fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftLine.key, quantity: 0 })
        });
    }

    async function addGiftVariant(variantId) {
        await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
    }

    // ————— Swap atomique : l'ancienne ligne (si présente) et la nouvelle variante sont mutées
    // en un seul appel /cart/update.js, pour qu'il n'existe jamais d'état "panier sans pochette". —————
    async function swapGiftVariant(existingLine, newVariantId) {
        const updates = {};
        // /cart/update.js ne reconnaît que des variant IDs comme clés, pas la line item key.
        if (existingLine) updates[String(existingLine.variant_id)] = 0;
        updates[String(newVariantId)] = 1;

        await fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates })
        });
    }

    // ————— Une seule pochette à la fois : swap atomique + un seul refresh du drawer —————
    async function selectGiftVariant(section, card) {
        if (section.__crpActionBusy) return; // une vraie mutation panier est déjà en cours
        if (card.classList.contains('crp-gift-card--disabled') || card.classList.contains('crp-gift-card--selected')) return;

        // Invalide immédiatement tout cycle de lecture en cours (refresh passif) : le choix de la
        // cliente est prioritaire et ne doit jamais être écrasé par une réponse plus ancienne.
        nextRenderToken(section);

        const variantId = card.dataset.crpVariantId;
        const giftProductId = section.dataset.crpGiftProductId;

        section.__crpActionBusy = true;
        qsa('[data-crp-gift-card]', section).forEach(c => c.classList.add('crp-gift-card--pending'));

        try {
            const cart = await fetchCart();
            const existingGiftLine = getGiftLine(cart, giftProductId);
            if (!existingGiftLine || String(existingGiftLine.variant_id) !== variantId) {
                await swapGiftVariant(existingGiftLine, variantId);
                dispatchDrawerRefresh();
            }
        } finally {
            qsa('[data-crp-gift-card]', section).forEach(c => c.classList.remove('crp-gift-card--pending'));
            section.__crpActionBusy = false;
        }

        await computeAndRender(section);
    }

    // Le radio est natif et la card entière est son <label> : cliquer sur l'image, le texte ou un
    // espace vide le coche nativement (y compris au clavier), ce qui déclenche "change" ici — sans
    // dépendre de la propagation d'un simple "click" qu'un autre script du thème pourrait stopper.
    function bindGiftSelector(section) {
        if (section.dataset.giftBound === '1') return;
        section.dataset.giftBound = '1';
        qsa('.crp-gift-radio', section).forEach(radio => {
            radio.addEventListener('change', () => {
                const card = radio.closest('[data-crp-gift-card]');
                if (card) selectGiftVariant(section, card);
            });
        });
    }

    // ————— Lecture du panier + mise à jour de l'affichage : jamais bloquante, protégée par le render token —————
    async function computeAndRender(section) {
        const token = nextRenderToken(section);
        const thresholdCents = Number(section.dataset.crpThresholdCents || 0);
        const giftProductId = section.dataset.crpGiftProductId || null;

        const cart = await fetchCart();
        if (!cart) return;
        if (section.__crpToken !== token) return; // un cycle plus récent a pris le relais entre-temps

        let giftLine = getGiftLine(cart, giftProductId);
        // Une pochette déjà offerte ne doit jamais contribuer elle-même au seuil.
        const eligibleCents = cart.items.reduce((sum, item) => {
            if (giftProductId && String(item.product_id) === String(giftProductId)) return sum;
            return sum + item.line_price;
        }, 0);

        const ratio = Math.max(0, Math.min(1, (thresholdCents ? eligibleCents / thresholdCents : 0)));
        const missingCents = Math.max(0, thresholdCents - eligibleCents);
        const reached = ratio >= 1;

        setIdleText(section, missingCents);
        setReachedText(section);

        const fill = qs('.crp-bar-fill', section);
        if (fill) fill.style.width = (ratio * 100).toFixed(2) + '%';

        section.classList.toggle('crp-reached', reached);

        // Les auto-mutations (retrait sous le seuil, ajout par défaut) ne doivent jamais démarrer
        // pendant qu'une vraie action utilisateur est en cours : son choix reste prioritaire.
        if (!section.__crpActionBusy) {
            if (!reached && giftLine) {
                // Repassée sous le seuil : la pochette n'est plus gratuite, on la retire.
                section.__crpActionBusy = true;
                try {
                    await removeGiftLine(giftLine);
                    dispatchDrawerRefresh();
                    giftLine = null;
                } finally {
                    section.__crpActionBusy = false;
                }
            } else if (reached && !giftLine) {
                // Seuil tout juste atteint et aucune pochette choisie : Blanche par défaut.
                const defaultCard = qs('[data-crp-gift-default]', section);
                if (defaultCard && !defaultCard.classList.contains('crp-gift-card--disabled')) {
                    section.__crpActionBusy = true;
                    try {
                        await addGiftVariant(defaultCard.dataset.crpVariantId);
                        dispatchDrawerRefresh();
                        const updatedCart = await fetchCart();
                        giftLine = getGiftLine(updatedCart, giftProductId);
                    } finally {
                        section.__crpActionBusy = false;
                    }
                }
            }
        }

        if (section.__crpToken !== token) return; // un choix plus récent a eu lieu entre-temps
        syncGiftSelection(section, reached ? giftLine : null);
    }

    // ————— Simple relecture passive du panier : jamais verrouillante, jamais prioritaire sur un clic —————
    async function refresh(section) {
        await computeAndRender(section);
    }

    // ————— Throttle des refresh pour éviter le clignotement —————
    function observeDrawer(section) {
        const drawer = qs(SELECTOR_DRAWER);
        if (!drawer) return;
        let tid = null;
        const mo = new MutationObserver(() => {
            clearTimeout(tid);
            tid = setTimeout(() => refresh(section), 120);
        });
        mo.observe(drawer, { childList: true, subtree: true });
    }

    function init() {
        qsa(SELECTOR_SECTION).forEach(section => {
            if (section.dataset.__crpReady) return;
            section.dataset.__crpReady = '1';
            moveIntoDrawer(section);
            // Bind une fois le template puis premier rendu
            bindIdleTemplate(section);
            bindGiftSelector(section);
            refresh(section);
            observeDrawer(section);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();